module.exports = __webpack_public_path__ + "386529849e617d9274565353533404b5.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/amplification/social-ig.png
// module id = 3280
// module chunks = 69